import { slotDefinition } from "../configs/slotDefinition.config.js";
import { openPopup } from "./helpers/openPopup.js";

export async function settings(scope, ctx) {
    const { scenes, data, gameLogic, audio, hud } = ctx;

    hud.setPopupState();

    const popup = await openPopup(scope, scenes, "SystemSettingsPopupScene", {
        totalBets: slotDefinition.bets,
        bet: gameLogic.bet,
        isMusicMuted: data.isMusicMuted,
        isSfxMuted: data.isSfxMuted,
    });

    scope.on(popup.onChangeAmbientMusic, (value) => {
        data.isMusicMuted = !value;
        ctx.setMusicMuted(!value);
    });

    scope.on(popup.onChangeSoundFX, (value) => {
        data.isSfxMuted = !value;
        try { audio.muteSfx(!value); } catch (e) { console.warn("muteSfx:", e.message); }
    });

    scope.on(popup.onTotalBetChanged, async (totalBet) => {
        await gameLogic.setBet(totalBet);
        ctx.hud.setBet(gameLogic.bet);
    });

    await scope.wait(popup.onPressClose);
}
